import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import type { IAction, User } from '@ztechapps/common.contract'

@InputType()
export class JoinSchoolArgs extends ActionArgs {
  /** The school's `Company.code`, typed by the teacher or resolved from an invite's school. */
  @Field(() => String)
  joinCode: string
}

/**
 * The single place a teacher becomes a member of a school — resolves the school from
 * `joinCode`, moves the teacher's whole balance into the pool, and repoints `user.company`.
 * Reused by both join paths: `SchoolResolver.schoolJoinByCode` calls it directly with the
 * code the teacher typed; `RedeemSchoolInvite` calls it with the invite's school's CURRENT
 * join code (read server-side off the `Company` document, never the code captured at invite
 * time), so a code rotation after the invite was sent never breaks it.
 */
export interface IJoinSchool extends IAction<User, JoinSchoolArgs> {}
